import { Component, OnDestroy, OnInit } from "@angular/core";
import { UserService } from "./core/services/user.service";
import { Subscription } from "rxjs";
import { SvgIconService } from "@merri/common";
import { NavLink } from "./core/models/nav-link";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  authed: boolean;
  userSub$: Subscription;

  navLinks: NavLink[] = [
    {
      label: "SKU",
      link: "/sku",
      icon: "calendar_view_day",
    },
    {
      label: "Models",
      link: "/models",
      icon: "photo_library",
    },
    {
      label: "Materials",
      link: "/materials",
      icon: "texture",
    },
    {
      label: "Venues",
      link: "/venues",
      icon: "location_city",
    },
    {
      label: "Vendors",
      link: "/vendors",
      icon: "people",
    },
    {
      label: "Taxonomy",
      link: "/taxonomy",
      icon: "show_chart",
    },
    {
      label: "Sketch Tool",
      link: "/sketch-tool",
      icon: "polyline",
    },
  ];

  constructor(private userService: UserService, private svgIconService: SvgIconService) {}

  ngOnInit() {
    this.userSub$ = this.userService.user$.subscribe(user => {
      this.authed = !!user;
    });
  }

  ngOnDestroy() {
    if (this.userSub$) this.userSub$.unsubscribe();
  }
}
